import e, { useState as f, useEffect as v } from "react";
import _ from "classnames";
import t from "./index178.mjs";
import g from "./index179.mjs";
import N from "./index180.mjs";
import { generateUniqueId as w } from "./index181.mjs";
const h = ({
  children: m,
  title: p,
  icon: i,
  expand: n = !1,
  setExpand: l,
  subtitle: b,
  className: u,
  footer: E,
  isDisabled: o,
  childId: s
}) => {
  const [a, r] = f(n), c = s || w("collapsible-content");
  v(() => {
    n !== void 0 && r(n);
  }, [n]);
  const d = () => {
    o || (l ? l(!a) : r(!a));
  };
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      id: "collapsible_container",
      "data-testid": "collapsible-container",
      className: t.collapsible_container
    },
    /* @__PURE__ */ e.createElement("div", { className: t.header, onClick: d }, i ? /* @__PURE__ */ e.createElement("div", { "data-testid": "headerButton", className: t.header_icon }, i) : null, /* @__PURE__ */ e.createElement("div", { className: t.title_wrapper }, /* @__PURE__ */ e.createElement("div", { className: t.title }, p), a ? null : /* @__PURE__ */ e.createElement("div", { className: t.subtitle, "data-testid": "subtitle" }, b)), /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        disabled: o,
        onClick: d,
        "data-testid": "expand-button",
        className: t.arrow_button,
        "aria-expanded": a,
        "aria-controls": c,
        "aria-label": a ? I18n.t("booking_engine.accessibility.collapse_section") : I18n.t("booking_engine.accessibility.expand_section")
      },
      a ? /* @__PURE__ */ e.createElement(g, { "data-testid": "collapse-arrow" }) : /* @__PURE__ */ e.createElement(N, { "data-testid": "expand-arrow" })
    )),
    /* @__PURE__ */ e.createElement(
      "div",
      {
        id: c,
        className: _([
          t.content,
          {
            [t.expanded]: a
          }
        ]),
        "data-testid": "content"
      },
      /* @__PURE__ */ e.createElement("div", { id: s, className: u }, m),
      E
    )
  );
};
export {
  h as CollapsibleContainer
};
